<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="show"
      variant="transparent"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      :spinner-variant="spinnerVariant"
      no-wrap
    >
      <template #overlay>
        <div class="d-flex justify-content-center align-items-center h-100">
          <b-spinner
            class="custom-spinner"
            :variant="spinnerVariant"
          />
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay, BSpinner } from 'bootstrap-vue'

export default {
  name: 'Spinner',
  components: {
    BOverlay,
    BSpinner,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    spinnerVariant: {
      type: String,
      default: 'primary',
    },
  },

}
</script>

<style lang="scss" scoped>
// CSS custom properties for easy overwriting
.custom-spinner {
  --spinner-color: var(--primary);
  color: var(--spinner-color) !important;
}
</style>
